import Vue from 'vue'
import auth from '../auth'

const API_URL = process.env.API_URL

export default {
  postRequest (route, addAuthHeader, body, callback) {
    let options = {emulateJSON: true}
    if (addAuthHeader) {
      options = {emulateJSON: true, headers: auth.getAuthHeader()}
    }
    Vue.http.post(API_URL + route, body, options).then(response => {
      callback(response, false)
    }, response => {
      callback(response, true)
    })
  },
  getRequest (route, addAuthHeader, callback) {
    let options = {}
    if (addAuthHeader) {
      options = {headers: auth.getAuthHeader()}
    }
    Vue.http.get(API_URL + route, options).then(response => {
      callback(response, false)
    }, response => {
      callback(response, true)
    })
  },
  deleteRequest (route, addAuthHeader, callback) {
    let options = {}
    if (addAuthHeader) {
      options = {headers: auth.getAuthHeader()}
    }
    Vue.http.delete(API_URL + route, options).then(response => {
      callback(response, false)
    }, response => {
      callback(response, true)
    })
  },
  patchRequest (route, addAuthHeader, body, callback) {
    let options = {emulateJSON: true}
    if (addAuthHeader) {
      options = {emulateJSON: true, headers: auth.getAuthHeader()}
    }
    Vue.http.patch(API_URL + route, body, options).then(response => {
      callback(response, false)
    }, response => {
      callback(response, true)
    })
  },
  putRequest (route, addAuthHeader, body, callback) {
    let options = {emulateJSON: true}
    if (addAuthHeader) {
      options = {emulateJSON: true, headers: auth.getAuthHeader()}
    }
    Vue.http.put(API_URL + route, body, options).then(response => {
      callback(response, false)
    }, response => {
      callback(response, true)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/rest/helper.js